//
//
//
//
//
//
//
//
//
//
//
//

export default {
    components: {},
    props: {
        title: {
            required: false,
            type: String,
            default: 'Actions'
        },
        direction: {
            required: false,
            type: String,
            default: 'right'
        }
    },
    data: function data() {
        return {
            directionClass: this.direction === 'right' ? 'direction-right' : 'direction-left',
            positioningClass: this.direction === 'right' ? 'right' : 'left',
            isOpen: false,
            uid: '_' + Math.random().toString(36).substr(2, 9)
        };
    },

    methods: {
        // open and close the dropdown menu.
        toggleMenu: function toggleMenu(e) {
            this.isOpen = !this.isOpen;
            e.stopPropagation();
        },

        // close the menu when the user clicks outside it while it's open.
        handleOutsideClickEvent: function handleOutsideClickEvent(e) {
            var _this = this;

            document.onclick = function (e) {
                if (_this.isOpen) {
                    var el = document.getElementById(_this.uid);
                    if (!el.contains(e.target)) {
                        _this.isOpen = false;
                    }
                }
            };
        }
    },
    mounted: function mounted() {
        this.handleOutsideClickEvent();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/Actions.vue
// module id = 8HxS
// module chunks = 0 1